import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'customDateHeure',
  standalone: true
})
export class CustomDateHeurePipe implements PipeTransform {

  constructor(private translateService: TranslateService) { }
  private datePipe !: DatePipe;

  transform(value: any): string {
    const currentLang = this.translateService.currentLang;
    switch (currentLang) {
      case 'fr':
        this.datePipe =new DatePipe('fr-CA')
        return this.datePipe.transform(value, 'yyyy-MM-dd HH:mm') || '';
      case 'en':
        this.datePipe =new DatePipe('en-CA')
        return this.datePipe.transform(value, 'yyyy-MM-dd HH:mm') || '';
      case 'es':
        this.datePipe =new DatePipe('es')
        return this.datePipe.transform(value, 'dd-MM-yyyy HH:mm') || '';
      default:
        this.datePipe =new DatePipe('fr-CA')
        return this.datePipe.transform(value, 'yyyy-MM-dd HH:mm') || '';
    }
  }
}
